import * as React from "react";
import {useTranslation} from "react-i18next";
import {getShopId} from "../getShopId";
import {useEffect, useRef} from "react";
import SwiperElement from "../../molecules/SwiperElement";
import {SwiperElementType} from "../../molecules/SwiperTypes";
import AdvantageBannerAutoplayer from "../../swipers/AdvantageBannerAutoplayer";
import {getReturnPolicyDays} from "../../../helpers/getReturnPolicyDays";

const swiperBannerParams = {
  loop: true,
  speed: 500,
  navigation: {
    nextEl: ".advantage-banner--next-button",
    prevEl: ".advantage-banner--prev-button",
  },
  spaceBetween: 0,
  slidesOffsetBefore: 0,
  slidesOffsetAfter: 0,
};

/* --Mobile Swiper-- */
const AdvantagesBannerMobile: React.FC = () => {
  const {t} = useTranslation();
  const divRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let localRef: SwiperElementType | undefined;
    if (divRef.current) {
      localRef = SwiperElement.run(divRef.current, swiperBannerParams);
    }
    let autoPlayer: AdvantageBannerAutoplayer | undefined;
    if (localRef) {
      autoPlayer = new AdvantageBannerAutoplayer(localRef);
    }

    return () => {
      autoPlayer?.destroy();
      localRef?.swiper.destroy();
    };
  }, []);

  return (
    <div className="advantage-banner" ref={divRef}>
      <swiper-container init={false}>
        {!!getReturnPolicyDays() && (
          <swiper-slide class="advantage-banner--content">
            <span className="icon icon-check--lightgreen"></span>
            <span>
              {t("general.returnPolicy--days", {days: getReturnPolicyDays()})}
              {getShopId() === 100005 && <sup className="footnote-reference footnote-reference--top">3</sup>}
            </span>
          </swiper-slide>
        )}
        <swiper-slide class="advantage-banner--content">
          <span className="icon icon-check--lightgreen"></span>
          <span>
            {t("general.originalDesignBrands")}
            {getShopId() === 100005 && <sup className="footnote-reference footnote-reference--top">3</sup>}
          </span>
        </swiper-slide>
        <swiper-slide class="advantage-banner--content">
          <span className="icon icon-check--lightgreen"></span>
          <span>{t("general.24000products--cnt", {cnt: Intl.NumberFormat([]).format(24000)})}</span>
        </swiper-slide>
      </swiper-container>
      <div className="advantage-banner--prev-button">
        <span className="icon icon-chevron-left">&#160;</span>
      </div>
      <div className="advantage-banner--next-button">
        <span className="icon icon-chevron-right">&#160;</span>
      </div>
    </div>
  );
};

export default AdvantagesBannerMobile;
